import { Radio as AntRadio } from 'antd'
import styled from 'styled-components'

import type {
  T_RadioProps,
  T_RadioGroupProps,
} from '@/components/radio/radio'
import { E_Colors } from '@/helpers/colors'


export const SC_RadioGroup = styled(
  (props: T_RadioGroupProps) => <AntRadio.Group {...props} />
)`
  display: flex;

  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none !important;
  }

  .ant-radio-button-wrapper-checked {
    background-color: ${E_Colors.TextPrimary};
  }

  ${({ customType }) => (
    customType === 'view-page' &&
    `
      gap: 12px;

      .ant-radio-button-wrapper {
        border-radius: 8px !important;
        background-color: transparent;
        padding: 8px;
        width: 44px !important;
        height: 44px !important;

        &.ant-radio-button-wrapper-checked {
          background-color: ${E_Colors.TextPrimary} !important;

          img {
            filter: brightness(0) invert(1);
          }
        }
      }
    `
  )}

  ${({ customType }) => (
    customType === 'column' &&
    `
      gap: 4px;
      flex-wrap: wrap;

      .ant-radio-button-wrapper {
        align-items: center;
        border-radius: 8px !important;
        background-color: ${E_Colors.GrayF2F2F7} !important;
        padding: 8px;
        flex: 1;
        height: 45px !important;

        &.ant-radio-button-wrapper-checked {
          background-color: ${E_Colors.TextPrimary} !important;

          h2 {
            color: ${E_Colors.White} !important;
          }
        }
      }
    `
  )}

  ${({ customType }) => (
    customType === 'fuel' &&
    `
      gap: 4px;
      flex-wrap: wrap;

      .ant-radio-button-wrapper {
        align-items: center;
        flex-direction: column;
        border-radius: 12px !important;
        padding: 15px;
        flex: 1 1 calc(50% - 8px);
        height: 48px;
      }
    `
  )}

  ${({ customType }) => (
    customType === 'volume' &&
    `
      background-color: ${E_Colors.GrayF2F2F7};
      height: 54px;
      align-items: center;
      border-radius: 12px;
      padding: 4px;

      .ant-radio-button-wrapper {
        align-items: center;
        flex-direction: column;
        border-radius: 8px !important;
        flex: 1 1 calc(50% - 8px);
        height: 46px;
        background-color: transparent;

        h4 {
          font-weight: 400;
        }

        &.ant-radio-button-wrapper-checked {
          background-color: ${E_Colors.TextPrimary} !important;

          h4 {
            color: ${E_Colors.White} !important;
          }
        }
      }
    `
  )}

  ${({ customType }) =>
    customType === 'payment' &&
    `
      flex-direction: column;
      gap: 10px;

      .ant-radio-wrapper {
        display: flex;
        flex-direction: row-reverse;
        background-color: ${E_Colors.GrayF2F2F7};
        border-radius: 10px;
        margin: 0;
        height: 44px;
        align-items: center;
        padding: 8px 7px;

        .ant-radio-label {
          margin-right: auto;
          padding: 0;
        }

        .ant-radio {
          height: 18px;
          width: 18px;
          margin: 0 5px;

          .ant-radio-inner {
            background-color: transparent;
            border: 2px solid ${E_Colors.MainColorAccent};
            height: 18px;
            width: 18px;
          }

          &.ant-radio-checked {
            .ant-radio-inner::after {
              background-color: ${E_Colors.MainColorAccent};
              width: 26px;
              height: 26px;
              margin-block-start: -13px;
              margin-inline-start: -13px;
              border-radius: 26px;
            }
          }
        }

        &.ant-radio-wrapper-checked {
          background-color: ${E_Colors.White} !important;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.10);
        }
      }
    `
}
`

export const SC_Radio = styled(
  (props: T_RadioProps) => <AntRadio {...props} />
)`
`

export const SC_RadioButton = styled(
  (props: T_RadioProps) => <AntRadio.Button {...props} />
)`
  display: flex;
  justify-content: center;
  border: none !important;
`
